// Components/ChatContacts/ChatContacts.jsx
import React, { useState, useRef } from "react";
import { Box, Typography } from '@mui/material';
import SearchBar from "./components/SearchBar";
import FilterToggle from "./components/FilterToggle";
import ContactsList from "./components/ContactsList";
import EmptyState from "./components/EmptyState";
import { useFilteredContacts } from "./hooks/useFilteredContacts";
import { useContactsObserver } from "./hooks/useContactsObserver";

const ChatContacts = ({
    contacts,
    selectUser,
    isMobile,
    loadingContactMessages,
    loadedContactIds = [],
    contactActive,
    userLoggedIn
}) => {
    // Estados y refs
    const [searchQuery, setSearchQuery] = useState('');
    const [filterType, setFilterType] = useState('all');
    const listRef = useRef(null);
    const contactRefs = useRef({});

    // Manejar cambio en el filtro
    const handleFilterChange = (event, newFilterType) => {
        if (newFilterType !== null) {
            setFilterType(newFilterType);
        }
    };

    // Filtrar contactos basados en búsqueda y tipo de filtro
    const { filteredContacts, unreadCount } = useFilteredContacts(
        contacts,
        searchQuery,
        filterType
    );

    // Configurar y manejar el intersection observer para lazy loading
    useContactsObserver(
        filteredContacts,
        listRef,
        contactRefs
    );

    // Verificar si un contacto está en proceso de carga
    const isContactLoading = (contactId) => {
        return loadingContactMessages && loadingContactMessages[contactId] === true;
    };

    // Verificar si los mensajes de un contacto ya se cargaron
    const isContactLoaded = (contactId) => {
        const stringId = contactId.toString();
        return Array.isArray(loadedContactIds) && loadedContactIds.includes(stringId);
    };

    // Establecer referencias para intersection observer
    const setContactRef = (id, element) => {
        if (element && !contactRefs.current[id]) {
            contactRefs.current[id] = element;
        }
    };

    return (
        <Box>
            <Typography variant="h6">Chats</Typography>
            {userLoggedIn ? (
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        height: isMobile ? "80vh" : "90vh",
                    }}
                >
                    <SearchBar
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                    />

                    <FilterToggle
                        filterType={filterType}
                        handleFilterChange={handleFilterChange}
                        unreadCount={unreadCount}
                    />

                    {filteredContacts.length === 0 ? (
                        <EmptyState
                            filterType={filterType}
                            searchQuery={searchQuery}
                        />
                    ) : (
                        <ContactsList
                            listRef={listRef}
                            contacts={filteredContacts}
                            setContactRef={setContactRef}
                            isContactLoading={isContactLoading}
                            isContactLoaded={isContactLoaded}
                            selectUser={selectUser}
                            isMobile={isMobile}
                            contactActive={contactActive}
                        />
                    )}
                </Box>
            ) : ""}
        </Box>
    );
};

export default ChatContacts;